import { useEffect } from 'react'
import {
    FaUsersGear,
    FaFileInvoiceDollar,
    FaNetworkWired,
    FaShieldHalved,
    FaChartLine,
    FaWifi,
    FaMobileScreenButton,
    FaPuzzlePiece,
  } from 'react-icons/fa6'
  
  const features = [
    {
      icon: FaUsersGear,
      title: 'Manajemen Pelanggan',
      desc: 'Kelola data pelanggan secara lengkap mulai dari pendaftaran, perubahan paket, hingga penonaktifan akun.',
    },
    {
      icon: FaFileInvoiceDollar,
      title: 'Billing Otomatis',
      desc: 'Generate tagihan bulanan otomatis, kirim invoice ke email atau WhatsApp pelanggan tanpa intervensi manual.',
    },
    {
      icon: FaNetworkWired,
      title: 'Integrasi Mikrotik',
      desc: 'Koneksi langsung dengan Mikrotik RouterOS via API untuk kontrol PPPoE, Hotspot, dan Queue secara real-time.',
    },
    {
      icon: FaShieldHalved,
      title: 'Auto Isolir Cerdas',
      desc: 'Sistem isolasi otomatis berdasarkan status pembayaran dengan pengaturan grace period yang fleksibel.',
    },
    {
      icon: FaChartLine,
      title: 'Laporan & Analitik',
      desc: 'Laporan keuangan, grafik pertumbuhan pelanggan, churn rate, dan analitik jaringan yang komprehensif.',
    },
    {
      icon: FaWifi,
      title: 'Monitoring Bandwidth',
      desc: 'Pantau penggunaan bandwidth per pelanggan secara real-time dan deteksi anomali penggunaan.',
    },
    {
      icon: FaMobileScreenButton,
      title: 'Akses Mobile',
      desc: 'Dashboard responsif yang bisa diakses dari smartphone, tablet, maupun laptop kapan saja.',
    },
    {
      icon: FaPuzzlePiece,
      title: 'API & Integrasi',
      desc: 'RESTful API yang lengkap untuk integrasi dengan payment gateway, WhatsApp bot, atau aplikasi pihak ketiga.',
    },
  ]
  
  export default function LpFeaturesSection() {
    return (
      <section
        id="fitur"
        className="w-full relative py-24 lg:py-32 overflow-hidden"
        aria-labelledby="fitur-heading"
      >
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center max-w-2xl mx-auto mb-16 reveal">
            <span className="text-ocean-600 font-semibold text-sm tracking-wider uppercase mb-4 block">
              Fitur Unggulan
            </span>
            <h2
              id="fitur-heading"
              className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-6"
            >
              Semua yang Anda Butuhkan{' '}
              <span className="gradient-text">dalam Satu Platform</span>
            </h2>
            <p className="text-slate-custom text-lg leading-relaxed">
              Fitur lengkap yang dirancang khusus untuk memenuhi kebutuhan
              operasional ISP dan RT/RW Net di Indonesia.
            </p>
          </div>
  
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((f, i) => {
              const Icon = f.icon
              return (
                <article
                  key={i}
                  className="card-glow rounded-2xl p-6 reveal"
                  style={{ transitionDelay: i * 0.08 + 's' }}
                >
                  <div className="feature-icon mb-5">
                    <Icon className="text-ocean-500 text-lg" />
                  </div>
                  <h3 className="font-display font-semibold text-white text-base mb-3">
                    {f.title}
                  </h3>
                  <p className="text-slate-custom text-sm leading-relaxed">
                    {f.desc}
                  </p>
                </article>
              )
            })}
          </div>
        </div>
      </section>
    )
  }